































import { Vue, Component, Prop, Watch, Inject } from "@/shared/vuepack";
import {
  Address,
  EmployerEditSuppressionType,
  UserRoleNames
} from "@/shared/types";
import { CompanyDetails, EmployerProfileRequest } from "@/employer/types";
import { Validator } from "vee-validate";
import EmployerAddress from "@/employer/components/shared/EmployerAddress.vue";
import CompanyInfo from "./CompanyInfo.vue";
import BankInfo from "./BankInfo.vue";
import Button from "@/shared/components/ui/Button.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import * as _ from "lodash";
import { useProfileStore } from "@/employer/store/profile";
import { usePartnerSettingStore } from "@/shared/store/partnerSetting";
import { useUserStore } from "@/shared/store/user";
import { useRoleStore } from "@/shared/store/role";
import * as routes from "@/employer/route-names";

@Component({
  components: {
    EmployerAddress,
    CompanyInfo,
    BankInfo,
    Button,
    ErrorSummary
  }
})
export default class CompanyDetailsForm extends Vue {
  EmployerEditSuppressionType = EmployerEditSuppressionType;
  profileStore = useProfileStore();
  partnerSettingStore = usePartnerSettingStore();
  userStore = useUserStore();
  roleStore = useRoleStore();

  @Inject() $validator: Validator;

  @Prop()
  employerId: number;

  @Prop()
  greyBackground: boolean;

  isSubmitting = false;
  partnerId = 0;
  companyDetails: CompanyDetails = null;

  initializeFromStateValue () {
    if (!this.profileStore.isLoaded) {
      return;
    }
    if (this.userStore.isApexUser()) {
      this.$router.push({ name: routes.SettingsEmployerAddress });
    }
    this.companyDetails = _.cloneDeep({
      profileInformation: this.profileStore.employerInformation,
      bankInformation: this.profileStore.bankInformation,
      fundingOption: null,
      enrollmentOption: null
    });
    this.partnerId = this.profileStore.employerInformation.partnerId;
    this.companyDetails.profileInformation.employerId = this.employerId;
  }

  mounted () {
    this.initializeFromStateValue();
    this.profileStore.loadProfileInformation(this.employerId);
  }

  @Watch("partnerId")
  onPartnerIdChange () {
    this.partnerSettingStore.loadEmployerPartnerSettings({
      partnerId: this.partnerId,
      employerId: this.employerId
    });
  }

  @Watch("profileStore.employerInformationState")
  onEmployeeInformationStateChange () {
    this.initializeFromStateValue();
  }

  @Watch("profileStore.bankInformationState")
  onBankInformationStateChange () {
    this.initializeFromStateValue();
  }

  get address (): Address {
    return {
      addressLine1: this.companyDetails.profileInformation.address1,
      addressLine2: this.companyDetails.profileInformation.address2,
      city: this.companyDetails.profileInformation.city,
      state: this.companyDetails.profileInformation.state,
      zip: this.companyDetails.profileInformation.zip
    };
  }

  set address (address: Address) {
    this.companyDetails.profileInformation.address1 = address.addressLine1;
    this.companyDetails.profileInformation.address2 = address.addressLine2;
    this.companyDetails.profileInformation.city = address.city;
    this.companyDetails.profileInformation.state = address.state;
    this.companyDetails.profileInformation.zip = address.zip;
  }

  onSubmit (formModel: CompanyDetails): void {
    if (this.isSubmitting) return;

    this.isSubmitting = true;
    this.$validator
      .validate()
      .then(isValid => {
        if (!isValid) return;

        this.profileStore.saveProfileInformation(formModel).then(() => this.$emit("complete"));
      })
      .finally(() => this.isSubmitting = false);
  }
  get editDisabled () {
    return (this.partnerSettingStore.settings && this.partnerSettingStore.settings.employerEditSuppressionType
      === EmployerEditSuppressionType.HsaBankImportedProperties);
  }

 createEmployerProfileRequest (formModel: CompanyDetails): EmployerProfileRequest {
    const wexProfile = formModel.profileInformation;

    return {
      employerCode: this.userStore.currentEmployer.wexEmployerCode,
      wexInstanceCode: this.userStore.user.wexInstanceCode,
      addressLine1: wexProfile.address1,
      addressLine2: wexProfile.address2 || undefined,
      city: wexProfile.city,
      state: wexProfile.state,
      zip: wexProfile.zip,
    };
  }
}
